import { datadogLogs } from "@datadog/browser-logs";
import IUser from "../models/IUser";
import { ErrorInfo } from "react";

export const LogService = {
    info: (message: string, data: any, userModel?: IUser) => {
        datadogLogs.logger.info(message, data);
    },
    error: (message: string, data: any) => {
        datadogLogs.logger.error(message, data);
    },
    warn: (message: string, data: any) => {
        datadogLogs.logger.warn(message, data);
    },
    // Special handler for React ErrorBoundary errors
    logReactError: (error: Error, errorInfo: ErrorInfo, context?: any) => {
        const errorData = {
            error: {
                message: error.message,
                stack: error.stack,
                name: error.name,
            },
            componentStack: errorInfo.componentStack,
            ...context,
        };

        datadogLogs.logger.error(`React ErrorBoundary: ${error.message}`, errorData);
    },
};
